import { NetworkService } from "./NetworkService";

export default class CouponsService {
  network;
  constructor(ntw: NetworkService) {
    this.network = ntw;
  }

  list = (filters = {}) => {
    return this.network.get(this.network.endpoints.coupons, filters);
  };

  create = (params) => {
    return this.network.post(this.network.endpoints.coupons, params);
  };

  update = (id, params) => {
    return this.network.put(`${this.network.endpoints.coupons}/${id}`, params);
  };

  show = (id) => {
    return this.network.get(`${this.network.endpoints.coupons}/${id}`);
  };

  delete = (id) => {
    return this.network.delete(`${this.network.endpoints.coupons}/${id}`);
  };

  listAvailablePlans = () => {
    return this.network.get(this.network.endpoints.couponsAvailablePlans);
  };

  listSubscribers = (id) => {
    return this.network.get(`${this.network.endpoints.coupons}/${id}/subscribers`);
  };
  getBillingCycle(billingCycle) {
    return billingCycle == "monthly" ? "Mensal" : "Anual";
  }
}
